import { DelayedRedirect } from "views/components/common/DelayedRedirect";
import { FlatButton } from "views/components/FlatButton";
import { Form, Input } from "views/components/common/Form";
import { Onboarding } from "views/desktop/components/Welcome";
import { Spacer } from "views/components/common/Spacer";
import { useAccount } from "hooks/recover";
import { validateEmail } from "lib/forms";
import React, { useState } from "reactn";
import { Alert } from "antd";

export const RecoverAccount = ({}) => {
	const [inputs, setInputs] = useState({});
	const [isDisabled, setIsDisabled] = useState(true);
	const handleChange = ({ target: { name, value } }) => {
		const validation = validateEmail(value);
		!validation ? setIsDisabled(true) : setIsDisabled(false);

		setInputs({
			...inputs,
			[name]: name === "user" ? value.toLowerCase() : value,
		});
	};

	const [recover, loading, resolved, error] = useAccount();

	if (resolved)
		return (
			<Onboarding>
				Le invitamos a revisar su bandeja de entrada, si el email
				corresponde a un usuario registrado se le enviara un correo con
				las instrucciones.
			</Onboarding>
		);

	return (
		<Onboarding>
			<div>
				<h4>Reestablece tu cuenta</h4>
				<Form>
					<Input
						validator={validateEmail}
						label="Correo electrónico"
						errorMessage="Mail inválido"
						name="user"
						value={inputs.user}
						onChange={handleChange}
					/>
					<Spacer rows={1} />
					<FlatButton
						loading={loading}
						text="Reestablecer cuenta"
						onClick={() => recover(inputs)}
						disabled={isDisabled}
					/>
				</Form>
				<Spacer rows={1} />
				{error && error.message && (
					<Alert
						message={"Error inesperado"}
						description={error.message}
						type="error"
					></Alert>
				)}
			</div>
		</Onboarding>
	);
};
